import Vue from 'vue';
import '@/assets/stylesheets/v2/_details-card.scss';
export default Vue.extend({
    props: {
        header: {
            type: String,
            required: true,
        },
    },
    render(createElement) {
        return createElement('v-card', {
            class: 'details-card',
        }, [
            createElement('v-layout', { class: 'align-center' }, [
                createElement('v-flex', { class: 'header grow' }, this.header),
                createElement('v-flex', {
                    slot: 'buttonTopRight',
                    class: 'shrink',
                }, this.$slots.buttonTopRight),
            ]),
            createElement('div', { class: 'body' }, this.$slots.default),
        ]);
    },
});
